routingConfiguration.$inject = ['mx.shell.RoutingService'];
export function routingConfiguration(routingService) {
	routingService.addItems([
		routingService.createRoutingItem({
			name: '404',
			viewUrl: 'layouts/page-not-found/404.html',
			path: null,
			title: 'Page Not Found',
			controller: 'mx.shell.PageNotFoundController',
		}),
		routingService.createRoutingItem({
			name: '401',
			viewUrl: 'layouts/unauthorized/401.html',
			path: null,
			title: 'Unauthorized',
			controller: 'mx.shell.UnauthorizedPageController',
		}),
		routingService.createRoutingItem({
			name: 'globalSearch',
			viewUrl: 'workspaces/SolutionBuilderAgent/layouts/global-search/global-search.html',
			path: '/global-search/:keyword?:contexts?:navigationId?:label?:showContexts?:extraContexts?',
			title: 'Global Search',
			controller: 'mx.SolutionBuilderAgent.GlobalSearchController',
		}),
	]);
}
